import { render, staticRenderFns } from "./BrTimeDistributionDetailModal.vue?vue&type=template&id=7a601fea&scoped=true"
import script from "./BrTimeDistributionDetailModal.vue?vue&type=script&lang=js"
export * from "./BrTimeDistributionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BrTimeDistributionDetailModal.vue?vue&type=style&index=0&id=7a601fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a601fea",
  null
  
)

export default component.exports